/**
 *  @class
 *  @function FacetsToggle
 */
class FacetsToggle {

  constructor() {
    this.container = document.getElementById('Facet-Drawer');
    let button = document.getElementById('Facets-Toggle');

    // Add functionality to buttons
    if (button) {
      button.addEventListener('click', (e) => {
        e.preventDefault();
        document.getElementsByTagName('body')[0].classList.toggle('open-cc');
        this.container.classList.toggle('active');
      });
    }
    setTimeout(function () {
      window.dispatchEvent(new Event('resize.resize-select'));
    }, 10);
  }
}


class FacetFiltersForm extends HTMLElement {
  constructor() {
    super();
    this.onActiveFilterClick = this.onActiveFilterClick.bind(this);

    this.debouncedOnSubmit = debounce((event) => {
      this.onSubmitHandler(event);
    }, 500);

    this.querySelector('form').addEventListener('input', this.debouncedOnSubmit.bind(this));
  }

  static setListeners() {
    const onHistoryChange = (event) => {
      const searchParams = event.state ? event.state.searchParams : FacetFiltersForm.searchParamsInitial;
      if (searchParams === FacetFiltersForm.searchParamsPrev) return;
      FacetFiltersForm.renderPage(searchParams, null, false);
    };
    window.addEventListener('popstate', onHistoryChange);
  }

  static toggleActiveFacets(disable = true) {
    document.querySelectorAll('.js-facet-remove').forEach((element) => {
      element.classList.toggle('disabled', disable);
    });
  }

  static renderPage(searchParams, event, updateURLHash = true) {
    FacetFiltersForm.searchParamsPrev = searchParams;
    // Invalidate any in-flight fetch before cache or network render.
    FacetFiltersForm.renderRequestId += 1;
    if (FacetFiltersForm.abortController) {
      FacetFiltersForm.abortController.abort();
      FacetFiltersForm.abortController = null;
    }
    const sections = FacetFiltersForm.getSections();
    const container = document.getElementsByClassName('thb-filter-count');
    document.getElementById('ProductGridContainer').querySelector('.collection').classList.add('loading');

    for (var item of container) {
      item.classList.add('loading');
    }

    sections.forEach((section) => {
      const url = `${window.location.pathname}?section_id=${section.section}&${searchParams}`;
      const filterDataUrl = element => element.url === url;

      if (FacetFiltersForm.filterData.some(filterDataUrl)) {
        FacetFiltersForm.renderSectionFromCache(filterDataUrl, event);
      } else {
        FacetFiltersForm.renderSectionFromFetch(url, event);
      }
    });
    if (updateURLHash) FacetFiltersForm.updateURLHash(searchParams);

  }

  static renderSectionFromFetch(url, event) {
    const controller = new AbortController();
    FacetFiltersForm.abortController = controller;
    // Capture id after renderPage already incremented; abort only this generation.
    const requestId = FacetFiltersForm.renderRequestId;

    fetch(url, { signal: controller.signal })
      .then(response => response.text())
      .then((responseText) => {
        if (requestId !== FacetFiltersForm.renderRequestId) return;

        const html = responseText;
        FacetFiltersForm.filterData = [...FacetFiltersForm.filterData, {
          html,
          url
        }];
        FacetFiltersForm.renderFilters(html, event);
        FacetFiltersForm.renderProductGridContainer(html);
        FacetFiltersForm.renderProductCount(html);

        new FacetsToggle();
      })
      .catch((error) => {
        if (error && error.name === 'AbortError') return;
        console.error('Facet filter fetch failed', error);
      });
  }

  static renderSectionFromCache(filterDataUrl, event) {
    const html = FacetFiltersForm.filterData.find(filterDataUrl).html;
    FacetFiltersForm.renderFilters(html, event);
    FacetFiltersForm.renderProductGridContainer(html);
    FacetFiltersForm.renderProductCount(html);

    new FacetsToggle();
  }

  static renderProductGridContainer(html) {
    const container = document.getElementById('ProductGridContainer');
    if (!container) return;

    const parsed = new DOMParser().parseFromString(html, 'text/html').getElementById('ProductGridContainer');
    if (!parsed) return;

    container.innerHTML = parsed.innerHTML;

    const headerHeight = parseInt(
      getComputedStyle(document.documentElement).getPropertyValue('--header-height'),
      10
    ) || 0;
    const offset = headerHeight + 30;
    const targetTop = container.getBoundingClientRect().top + window.scrollY - offset;

    // Skip tiny adjustments — smooth/CSS scroll stacking made these feel like jitter.
    if (Math.abs(window.scrollY - targetTop) < 100) return;

    // Prefer auto over smooth: html already has scroll-behavior:smooth, and
    // concurrent smooth scrolls bounce against infinite-scroll layout changes.
    window.scrollTo({
      top: Math.max(0, targetTop),
      left: 0,
      behavior: 'auto'
    });
  }

  static renderProductCount(html) {
    const countHtml = new DOMParser().parseFromString(html, 'text/html').getElementById('ProductCount');
    const container = document.getElementsByClassName('thb-filter-count');

    if (countHtml) {
      for (var item of container) {
        item.innerHTML = countHtml.innerHTML;
        item.classList.remove('loading');
      }
    }

  }

  static renderFilters(html, event) {
    const parsedHTML = new DOMParser().parseFromString(html, 'text/html');

    const facetDetailsElements =
      parsedHTML.querySelectorAll('#FacetFiltersForm collapsible-row, #FacetFiltersFormMobile collapsible-row');
    // Match rows by their stable filter param name, not forloop index. The index shifts when the
    // available filter set changes (e.g. the conditionally-rendered tacori filter, or filters that
    // drop out for a given result set), which made the lookup return null and abort the whole render.
    const keyOf = (element) => element.getAttribute('data-filter-param-name') || '';
    const formIdOf = (element) => element.closest('form')?.id || '';
    const jsFilter = event ? event.target.closest('collapsible-row') : undefined;
    const interactedKey = jsFilter ? keyOf(jsFilter) : null;
    const interactedFormId = jsFilter ? formIdOf(jsFilter) : null;
    // Only skip the exact form row that was clicked; still sync its desktop/mobile twin from the response.
    const shouldSkipFullRender = (element) =>
      interactedKey !== null &&
      keyOf(element) === interactedKey &&
      formIdOf(element) === interactedFormId;

    const facetsToRender = Array.from(facetDetailsElements).filter((element) => !shouldSkipFullRender(element));
    const countsToRender = Array.from(facetDetailsElements).find(
      (element) =>
        interactedKey !== null &&
        keyOf(element) === interactedKey &&
        formIdOf(element) === interactedFormId
    );

    facetsToRender.forEach((element) => {
      const key = keyOf(element);
      const formId = formIdOf(element);
      const target = formId
        ? document.querySelector(`#${CSS.escape(formId)} collapsible-row[data-filter-param-name="${CSS.escape(key)}"]`)
        : document.querySelector(`collapsible-row[data-filter-param-name="${CSS.escape(key)}"]`);
      if (target) target.innerHTML = element.innerHTML;
    });

    FacetFiltersForm.renderActiveFacets(parsedHTML);
    FacetFiltersForm.renderAdditionalElements(parsedHTML);
    new FacetsToggle();

    if (countsToRender) FacetFiltersForm.renderCounts(countsToRender, event.target.closest('collapsible-row'));
  }

  static renderActiveFacets(html) {
    const activeFacetElementSelectors = ['.active-facets'];

    activeFacetElementSelectors.forEach((selector) => {
      const activeFacetsElement = html.querySelector(selector);
      if (!activeFacetsElement) return;
      document.querySelector(selector).innerHTML = activeFacetsElement.innerHTML;
    });

    FacetFiltersForm.toggleActiveFacets(false);
  }

  static renderAdditionalElements(html) {
    const mobileElementSelectors = ['.mobile-filter-count'];

    mobileElementSelectors.forEach((selector) => {
      if (!html.querySelector(selector)) return;
      document.querySelector(selector).innerHTML = html.querySelector(selector).innerHTML;
    });

  }

  static renderCounts(source, target) {
    const targetElement = target.querySelector('.facets__selected');
    const sourceElement = source.querySelector('.facets__selected');

    if (sourceElement && targetElement) {
      target.querySelector('.facets__selected').outerHTML = source.querySelector('.facets__selected').outerHTML;
    }
  }

  static updateURLHash(searchParams) {
    history.pushState({
      searchParams
    }, '', `${window.location.pathname}${searchParams && '?'.concat(searchParams)}`);
  }

  static getSections() {
    return [
      {
        section: document.getElementById('product-grid').dataset.id,
      }];
  }

  onSubmitHandler(event) {
    event.preventDefault();
    const formData = new FormData(event.target.closest('form'));
    const searchParams = new URLSearchParams(formData);
    if (searchParams.get('filter.v.price.gte') === "0.00") {
      searchParams.delete('filter.v.price.gte');
    }
    if (document.querySelector('.price_slider')) {
      if (searchParams.get('filter.v.price.lte') === parseFloat(document.querySelector('.price_slider').dataset.max).toFixed(2)) {
        searchParams.delete('filter.v.price.lte');
      }
    }
    FacetFiltersForm.renderPage(searchParams.toString(), event);
  }

  onActiveFilterClick(event) {
    event.preventDefault();
    FacetFiltersForm.toggleActiveFacets();
    const url = event.currentTarget.href.indexOf('?') == -1 ? '' : event.currentTarget.href.slice(event.currentTarget.href.indexOf('?') + 1);
    FacetFiltersForm.renderPage(url);
  }
}

FacetFiltersForm.filterData = [];
FacetFiltersForm.searchParamsInitial = window.location.search.slice(1);
FacetFiltersForm.searchParamsPrev = window.location.search.slice(1);
FacetFiltersForm.renderRequestId = 0;
FacetFiltersForm.abortController = null;
customElements.define('facet-filters-form', FacetFiltersForm);
FacetFiltersForm.setListeners();

// Single-select groups (e.g. Metal Type) are marked with data-single-select.
// Checking one option unchecks the others in the same group (and the desktop/mobile twin)
// so a new selection can replace the previous without a manual deselect first.
FacetFiltersForm.enforceSingleSelect = function (changedInput) {
  if (!changedInput.checked) return;

  const paramName = changedInput.name;
  const groups = document.querySelectorAll('ul[data-single-select]');

  groups.forEach((group) => {
    group.querySelectorAll('input[type="checkbox"]').forEach((cb) => {
      if (cb.name !== paramName) return;

      const label = group.querySelector(`label[for="${cb.id}"]`);
      const shouldBeChecked = cb === changedInput || cb.value === changedInput.value;

      if (cb !== changedInput) cb.checked = shouldBeChecked;

      // Clear any leftover lockout from the previous exclusive-disable behavior.
      if (!label || !label.classList.contains('facet-checkbox--disabled')) {
        cb.disabled = false;
      }
      if (label) label.classList.remove('facet-checkbox--single-disabled');
    });
  });
};

// Keep desktop/mobile filter checkboxes in sync so FormData from either form keeps prior selections.
FacetFiltersForm.syncFilterCheckboxTwins = function (changedInput) {
  if (!changedInput.name || !changedInput.name.startsWith('filter.')) return;

  document.querySelectorAll(
    `facet-filters-form input[type="checkbox"][name="${CSS.escape(changedInput.name)}"]`
  ).forEach((twin) => {
    if (twin === changedInput) return;
    if (twin.value === changedInput.value) twin.checked = changedInput.checked;
  });
};

// Capture-phase input so siblings/twins update before the form's debounced submit reads FormData.
document.addEventListener('input', (event) => {
  const input = event.target;
  if (!(input instanceof HTMLInputElement) || input.type !== 'checkbox') return;
  if (!input.closest('facet-filters-form')) return;

  if (input.closest('ul[data-single-select]')) {
    FacetFiltersForm.enforceSingleSelect(input);
  }
  FacetFiltersForm.syncFilterCheckboxTwins(input);
}, true);


class FacetRemove extends HTMLElement {
  constructor() {
    super();
    this.querySelectorAll('a').forEach((item) => {
      item.addEventListener('click', (event) => {
        event.preventDefault();
        const form = this.closest('facet-filters-form') || document.querySelector('facet-filters-form');
        form.onActiveFilterClick(event);
      });
    });
  }
}

customElements.define('facet-remove', FacetRemove);

/**
 *  @class
 *  @function PriceSlider
 */
class PriceSlider extends HTMLElement {

  constructor() {
    super();
  }
  connectedCallback() {
    let slider = this.querySelector('.price_slider'),
      amounts = this.querySelector('.price_slider_amount'),
      args = {
        start: [parseFloat(slider.dataset.minValue || 0), parseFloat(slider.dataset.maxValue || slider.dataset.max)],
        connect: true,
        step: 10,
        direction: document.dir,
        handleAttributes: [
          { 'aria-label': 'lower' },
          { 'aria-label': 'upper' },
        ],
        range: {
          'min': 0,
          'max': parseFloat(slider.dataset.max)
        }
      },
      event = new CustomEvent('input'),
      form = this.closest('facet-filters-form') || document.querySelector('facet-filters-form');

    if (slider.classList.contains('noUi-target')) {
      slider.noUiSlider.destroy();
    }
    noUiSlider.create(slider, args);

    slider.noUiSlider.on('update', function (values) {
      amounts.querySelector('.field__input_min').value = values[0];
      amounts.querySelector('.field__input_max').value = values[1];
    });
    slider.noUiSlider.on('change', function (values) {
      form.querySelector('form').dispatchEvent(event);
    });
  }
}
customElements.define('price-slider', PriceSlider);

window.addEventListener('load', () => {
  new FacetsToggle();
});